module.exports = __webpack_public_path__ + "static/media/23.4d13b1e6.png";